<template>
<div class="chapter">
<div class="inner_page">
<h1>Sommario</h1>
<p><span href="#/c001" title="Link target outside of Sample">Titolo Pagina</span></p>
<p><span href="#/c002" title="Link target outside of Sample">Copyright Pagina</span></p>
<p><a href="#/c003">A Pezzi | Parte Ottava | SKY CORGAN</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?d372bc7e